import { useMutation } from "@tanstack/react-query";
import { previewUsageLink } from "../services/preview-usage-link";

export function usePreviewUsageLink() {
  return useMutation({
    mutationFn: ({
      source_id,
      usage_identifier,
    }: {
      source_id: string;
      usage_identifier: string;
    }) => previewUsageLink(source_id, usage_identifier),
  });
}
